import 'react-app-polyfill/ie11';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ConfigProvider, Spin, message } from 'antd';
import 'core-js/stable';
import store from './store';
import Routes from './routes';
import App from './components/App/App';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import { SpinIndicator } from './components/PageLoader/PageLoader';
import { validateEnv } from './utils/envValidation';
import { getApiErrorMessage, wasBusinessUnauthorizedHandled } from './utils/httpError';
import { unregister } from './registerServiceWorker';
import { applyPartnerTheme } from './themes/partnerTheme';
import './index.scss';

applyPartnerTheme();

window.addEventListener(
  'unhandledrejection',
  (event) => {
    const { reason } = event;
    if (!reason || typeof reason !== 'object') return;
    const isHttpFailure = reason.isHttpReject || reason.isAxiosError || reason.status || reason.response;
    if (!isHttpFailure) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (wasBusinessUnauthorizedHandled(reason)) return;

    const text = getApiErrorMessage(reason, 'Sorry, an error occurred. Please try again later.');
    if (text) message.error(text);
  },
  true,
);

Spin.setDefaultIndicator(<SpinIndicator />);

// Validate environment variables on app startup
// eslint-disable-next-line react/no-deprecated
validateEnv();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <ErrorBoundary>
    <Provider store={store}>
      <ConfigProvider>
        <App>
          <Routes />
        </App>
      </ConfigProvider>
    </Provider>
  </ErrorBoundary>,
);

unregister();
